import { render, staticRenderFns } from "./ColumnHighlights.vue?vue&type=template&id=79dc4c1f"
import script from "./ColumnHighlights.vue?vue&type=script&lang=ts"
export * from "./ColumnHighlights.vue?vue&type=script&lang=ts"
import style0 from "./ColumnHighlights.vue?vue&type=style&index=0&id=79dc4c1f&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79dc4c1f')) {
      api.createRecord('79dc4c1f', component.options)
    } else {
      api.reload('79dc4c1f', component.options)
    }
    module.hot.accept("./ColumnHighlights.vue?vue&type=template&id=79dc4c1f", function () {
      api.rerender('79dc4c1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/ColumnHighlights.vue"
export default component.exports